import type { BoardPoint, HomeworkSubmissionReplayResponse, StoneColor } from '@wx-weiqi/contracts';
import { classroomVisibleMarkers, type ClassroomMarkerMode } from './classroom-marker-display';

/** Replayed intersections can change map insertion order; display ranges follow move numbers. */
export function homeworkVisibleStoneLabels<T extends { readonly label: string }>(
  labels: readonly T[],
  mode: ClassroomMarkerMode,
  customCount: number,
): readonly T[] {
  return classroomVisibleMarkers(
    [...labels].sort((a, b) => Number(a.label) - Number(b.label)),
    mode,
    customCount,
  );
}

/** Label submitted moves using server replay frames; initial setup stones stay unnumbered. */
export function homeworkAnswerStoneLabels(
  frames: HomeworkSubmissionReplayResponse['data']['frames'],
  cursor: number,
) {
  const board = frames[cursor]?.board;
  if (board === undefined) return [];
  const labels = new Map<
    string,
    { readonly point: BoardPoint; readonly label: string; readonly color: StoneColor }
  >();
  for (const frame of frames.slice(1, cursor + 1)) {
    if (frame.move?.kind !== 'PLAY') continue;
    const point = frame.move.point;
    const color = frame.board.stones[point.y * frame.board.size + point.x];
    if (color !== 'BLACK' && color !== 'WHITE') continue;
    labels.set(`${point.x}:${point.y}`, { point, label: String(frame.moveNumber), color });
  }
  return [...labels.values()].filter(
    ({ point, color }) => board.stones[point.y * board.size + point.x] === color,
  );
}
